import {
    GET_STORE_LIST_SUCCESS,
    GET_STORE_LIST_FAILED,
    RESET_GET_STORE_LIST,
    LOADING_GET_STORE_LIST,
    NETWORK_ERROR_GET_STORE_LIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetStoreList = () => {
    return { type: RESET_GET_STORE_LIST };
};

const getStoreList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GET_STORE_LIST });
    await partnerServices
        .post("getStoreList", userData, { headers: { AuthToken: authTokenIs } })

        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getStoreListsuccess(res.data));
                    break;
                default:
                    dispatch(getStoreListfailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GET_STORE_LIST, payload: err });
        });
};

function getStoreListsuccess(data) {
    return {
        type: GET_STORE_LIST_SUCCESS,
        payload: data,
    };
}

function getStoreListfailed(data) {
    return {
        type: GET_STORE_LIST_FAILED,
        payload: data,
    };
}

export { resetGetStoreList, getStoreList };
